import i18n from 'utils/i18n'
import type { AdminMentionsFilterName } from 'utils/filters/admin'
import type { TableFiltersConfig } from 'components/Common/Table/Layout/Page/_methods/types'
import {
  filterTypes,
  CHECKBOX_LIST,
  DATE_INTERVAL,
  RADIO_LIST,
  INTERVAL,
  SWITCHER,
  RHEOSTAT,
  offersFiltersTitle,
  offersFiltersName,
  offersFiltersKey,
  SEARCH_USERS,
  MULTISELECT_SWITCHER,
  ADMIN_FILTERS_KEY,
  ADMIN_FILTERS_TITLE,
  ADMIN_FILTERS_NAME,
} from 'utils/consts'

export const getAdministrationMentionsFiltersCollection = () => [
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.mentionImages),
    filterName:
      ADMIN_FILTERS_NAME.mentionImages satisfies AdminMentionsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.mentionImages,
  },
  {
    type: filterTypes[RHEOSTAT],
    title: i18n.t(ADMIN_FILTERS_TITLE.confidenceFilter),
    filterName:
      ADMIN_FILTERS_NAME.confidenceFilter satisfies AdminMentionsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.confidenceFilter,
    maxFraction: 100000,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.modelVersionFilter),
    filterName:
      ADMIN_FILTERS_NAME.modelVersionFilter satisfies AdminMentionsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.modelVersionFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.isModelWineSetFilter),
    filterName:
      ADMIN_FILTERS_NAME.isModelWineSetFilter satisfies AdminMentionsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.isModelWineSetFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.userWineFilter),
    filterName:
      ADMIN_FILTERS_NAME.userWineFilter satisfies AdminMentionsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.userWineFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.authorUserRoleFilter),
    filterName:
      ADMIN_FILTERS_NAME.authorUserRoleFilter satisfies AdminMentionsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.authorUserRoleFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.pendingVerificationStepFilter),
    filterName:
      ADMIN_FILTERS_NAME.pendingVerificationStepFilter satisfies AdminMentionsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.pendingVerificationStepFilter,
    notUseLastUpdatedFilter: true,
    withCheckAll: true,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.checkedStepsFilter),
    filterName:
      ADMIN_FILTERS_NAME.checkedStepsFilter satisfies AdminMentionsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.checkedStepsFilter,
    withCheckAll: true,
    notUseLastUpdatedFilter: true,
  },
  {
    type: filterTypes[RHEOSTAT],
    title: i18n.t(ADMIN_FILTERS_TITLE.clusterMentionFilter),
    filterName:
      ADMIN_FILTERS_NAME.clusterMentionFilter satisfies AdminMentionsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.clusterMentionFilter,
  },

  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.invalidEntityFilter),
    filterName:
      ADMIN_FILTERS_NAME.invalidEntityFilter satisfies AdminMentionsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.invalidEntityFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.isModelUserWineMatchFilter),
    filterName:
      ADMIN_FILTERS_NAME.isModelUserWineMatchFilter satisfies AdminMentionsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.isModelUserWineMatchFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.diffFieldsFilter),
    filterName:
      ADMIN_FILTERS_NAME.diffFieldsFilter satisfies AdminMentionsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.diffFieldsFilter,
    notUseLastUpdatedFilter: true,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.rightnessFilter),
    filterName:
      ADMIN_FILTERS_NAME.rightnessFilter satisfies AdminMentionsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.rightnessFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.identificationFilter),
    filterName:
      ADMIN_FILTERS_NAME.identificationFilter satisfies AdminMentionsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.identificationFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.wineCountryFilter),
    filterName:
      ADMIN_FILTERS_NAME.wineCountryFilter satisfies AdminMentionsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.productCountryFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.producerFilter),
    filterName:
      ADMIN_FILTERS_NAME.producerFilter satisfies AdminMentionsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.tradeNameFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.hasVerifiedRepresentativeFilter),
    filterName:
      ADMIN_FILTERS_NAME.hasVerifiedRepresentativeFilter satisfies AdminMentionsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.hasVerifiedRepresentativeFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.productBrandFilter),
    filterName:
      ADMIN_FILTERS_NAME.productBrandFilter satisfies AdminMentionsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.productBrandFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.additionalNameFilter),
    filterName:
      ADMIN_FILTERS_NAME.additionalNameFilter satisfies AdminMentionsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.additionalNameFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.nationalGITypeFilter),
    filterName:
      ADMIN_FILTERS_NAME.nationalGITypeFilter satisfies AdminMentionsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.nationalGITypeFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.geoIndicationFilter),
    filterName:
      ADMIN_FILTERS_NAME.geoIndicationFilter satisfies AdminMentionsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.geoIndicationFilter,
  },

  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.specialClassificationFilter),
    filterName:
      ADMIN_FILTERS_NAME.specialClassificationFilter satisfies AdminMentionsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.specialClassificationFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.wineTypeFilter),
    filterName:
      ADMIN_FILTERS_NAME.wineTypeFilter satisfies AdminMentionsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.wineTypeFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.wineColourFilter),
    filterName:
      ADMIN_FILTERS_NAME.wineColourFilter satisfies AdminMentionsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.wineColourFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.sweetnessTypeFilter),
    filterName:
      ADMIN_FILTERS_NAME.sweetnessTypeFilter satisfies AdminMentionsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.sweetnessTypeFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.vintageFilter),
    filterName:
      ADMIN_FILTERS_NAME.vintageFilter satisfies AdminMentionsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.vintageFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.kindOfWineFilter),
    filterName:
      ADMIN_FILTERS_NAME.kindOfWineFilter satisfies AdminMentionsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.kindOfWineFilter,
  },
  {
    type: filterTypes[MULTISELECT_SWITCHER],
    title: i18n.t(offersFiltersTitle.grapesFilter),
    filterName: offersFiltersName.grapesFilter,
    apiFilterName: offersFiltersKey().grapesFilter,
    switchType: filterTypes[SWITCHER],
    switchFilterName: offersFiltersName.monocepageFilter,
    switchTitle: i18n.t(offersFiltersTitle.monocepageFilter),
    switchApiFilterName: 'grapeAndMonocepage',
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.hasBottleImageFilter),
    filterName:
      ADMIN_FILTERS_NAME.hasBottleImageFilter satisfies AdminMentionsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.hasBottleImageFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.hasFrontLabelImageFilter),
    filterName:
      ADMIN_FILTERS_NAME.hasFrontLabelImageFilter satisfies AdminMentionsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.hasFrontLabelImageFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.hasBackLabelImageFilter),
    filterName:
      ADMIN_FILTERS_NAME.hasBackLabelImageFilter satisfies AdminMentionsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.hasBackLabelImageFilter,
  },

  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.bottleSizeFilter),
    filterName:
      ADMIN_FILTERS_NAME.bottleSizeFilter satisfies AdminMentionsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.bottleSizeFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.packageTypeFilter),
    filterName:
      ADMIN_FILTERS_NAME.packageTypeFilter satisfies AdminMentionsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.packageTypeFilter,
  },
  {
    type: filterTypes[INTERVAL],
    title: i18n.t(ADMIN_FILTERS_TITLE.alcoholOnLabelFilter),
    filterName:
      ADMIN_FILTERS_NAME.alcoholLevelFilter satisfies AdminMentionsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.alcoholOnLabelFilter,
    defaultIntervalKey: 'alcoholLevels',
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.certificatesFilter),
    filterName:
      ADMIN_FILTERS_NAME.certificatesFilter satisfies AdminMentionsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.certificatesFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.sourceFilter),
    filterName:
      ADMIN_FILTERS_NAME.sourceFilter satisfies AdminMentionsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.sourceFilter,
    withCheckAll: true,
  },
  {
    type: filterTypes[DATE_INTERVAL],
    title: i18n.t(ADMIN_FILTERS_TITLE.aiWineDateFilter),
    filterName:
      ADMIN_FILTERS_NAME.aiWineDateFilter satisfies AdminMentionsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.aiWineDateFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.userEntitiesFilter),
    filterName:
      ADMIN_FILTERS_NAME.userEntitiesFilter satisfies AdminMentionsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.userEntitiesFilter,
    withCheckAll: true,
  },
  {
    type: filterTypes[SEARCH_USERS],
    title: i18n.t(ADMIN_FILTERS_TITLE.creationUserFilter),
    filterName:
      ADMIN_FILTERS_NAME.authorUserFilter satisfies AdminMentionsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.authorUserFilter,
  },
  {
    type: filterTypes[DATE_INTERVAL],
    title: i18n.t(ADMIN_FILTERS_TITLE.createdAtFilter),
    filterName:
      ADMIN_FILTERS_NAME.createdAtFilter satisfies AdminMentionsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.createdAtFilter,
  },
  {
    type: filterTypes[SEARCH_USERS],
    title: i18n.t(ADMIN_FILTERS_TITLE.verificationUserFilter),
    filterName:
      ADMIN_FILTERS_NAME.verificationUserFilter satisfies AdminMentionsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.verificationUserFilter,
  },
  {
    type: filterTypes[DATE_INTERVAL],
    title: i18n.t(ADMIN_FILTERS_TITLE.verificatedAtFilter),
    filterName:
      ADMIN_FILTERS_NAME.verificatedAtFilter satisfies AdminMentionsFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.verificatedAtFilter,
  },
]

export const adminMentionsFiltersConfig: TableFiltersConfig = {
  getFiltersCollection: getAdministrationMentionsFiltersCollection,
  pathToStore: [],
  filtersDataPath: ['admin', 'mentions', 'mentionsFilters'],
  showResultsTextKey: 'filters.button.apply',
  withShare: true,
}
